import { Icon } from '@ui/components';
import { TabDefinition } from '../creator-shell.types';
import { useRouter } from 'next/navigation';

interface Props {
  filteredTabs: TabDefinition[];
  isLoading: boolean;
  notificationData: any;
  currentTab: string;
  isAuthenticated: boolean;
  creatorProfile: boolean;
  handleTabClick: (tabId: string) => void;
}

const DesktopTab = (props: Props) => {
  const router = useRouter();
  return (
    <div
      className={`gap-4 hidden lg:flex items-center pb-8 lg:items-end lg:justify-between lg:pb-4 lg:pt-4 bg-white z-50 sticky top-0 ${
        props.isAuthenticated ? 'px-2 lg:px-14' : ''
      }`}>
      <div className="flex w-full items-center justify-around gap-4 whitespace-nowrap lg:w-fit">
        {!props.creatorProfile && (
          <div onClick={() => router.back()} className="flex items-center gap-4">
            <Icon type="back" />
          </div>
        )}
        {props.filteredTabs.map((tab) => (
          <div
            key={tab.id}
            className="relative"
            onClick={() => (props.isLoading ? null : props.handleTabClick(tab.id))}>
            {tab.notificationGetter && tab.notificationGetter(props.notificationData) > 0 && (
              <div
                className={`w-4 h-4 p-1 rounded-full bg-primary text-white absolute -top-1 -right-1 flex items-center justify-center text-xs ${
                  props.isLoading && 'opacity-35 z-10'
                }`}>
                {tab.notificationGetter(props.notificationData)}
              </div>
            )}
            <div
              className={`min-w-fit flex items-center gap-1 bg-input rounded-lg py-2 px-4 text-note 
        ${props.currentTab === tab.id ? 'text-primary' : ''}
        ${props.isLoading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}>
              {tab.icon && (
                <Icon
                  type={tab.icon}
                  className="w-4 h-4 mr-1"
                  stroke={props.currentTab === tab.id ? '#FF600D' : '#707B8F'}
                />
              )}
              {tab.id}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DesktopTab;
